export default {"src":"/_next/static/media/lock.e95a634c.svg","height":24,"width":24};